module.exports = __webpack_public_path__ + "c6c86d44153b91168d03960283e21224.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pro-era-joey.jpg
// module id = 503
// module chunks = 0